<div class="row">
  <ng-container>
    <div
      *ngIf="!isEditingEvidence"
      [ngClass]="isEditingHypothesis ? 'col-12' : 'col-6'"
    >
      <hypothesis-form-ras
        [(hypothesis)]="hypothesis"
        (changeValues)="setValues()"
      >
      </hypothesis-form-ras>
    </div>

    <div
      *ngIf="!isEditingHypothesis"
      [ngClass]="isEditingEvidence ? 'col-12' : 'col-6'"
    >
      <evidence-form-ras [(evidences)]="evidences" (changeValues)="setValues()">
      </evidence-form-ras>
    </div>
  </ng-container>

  <div class="col-12">
    <hypothesis-values-form-ras
      [(evidences)]="evidences"
      [(hypothesis)]="hypothesis"
      [(values)]="values"
      (changeValues)="setValues()"
    >
    </hypothesis-values-form-ras>
  </div>
</div>
